<app-file-management
  [fileTypesOverride]="fileTypes"
  (fileSelected)="submitImage($event)"
  (closeClicked)="onClose()">
</app-file-management>